import React from 'react';

import ContactSearchComponent from '@totem/components/contactSearch/contactSearchComponent';

const WidgetContactSearch = () => {
  return <ContactSearchComponent />;
};

export default WidgetContactSearch;
